import * as Resume from '../resume';
import '../css/storyline.css';

export function events(Player) {
  Player.on('ready', () => {
    // Add chapters
    Player.chapters ? Player.add_chapters(Player.chapters) : null;

    // Add interactions
    Player.interactions ? Player.add_interactions(Player.interactions) : null;

    // Add completion
    Player.completion ? Player.add_completion(Player.completion) : null;

    // Play video if not on iOS
    IVP.log('Checking playback..');
    if (!SL.get('isiOS')) {
      IVP.log('No iOS detected. Playing video.', 'ok');
      SL.set('vtPlayToggle', true);
    } else {
      IVP.log('iOS detected. Skipping video playback.', 'ok');
    }

    Player.on('loadedmetadata', () => {
      // Remove any existing subtitles
      Player.remove_subtitles();

      // Load a subtitle into the Player
      const subName = SL.get('vtSubName');
      const subSRC = './story_content/external_files/' + subName;
      subName ? Player.load_sub('en', 'English', subSRC, SL.get('vtSubsEnabled'), true) : null;

      // Set end time
      Player.endTime = Player.get_state().endTime;

      // Notify Storyline that the Player is ready
      SL.set('vtLoaded', true);

      // Seek time / chapter / interaction
      const seekChapter = SL.get('vtSeekChapter');
      const seekInteraction = SL.get('vtSeekInteraction');
      const seekTime = SL.get('vtTime');

      if (seekChapter > 0) {
        // Seek to chapter
        console.log(`Seeking Chapter ${seekChapter}`);
        Player.seek_chapter(seekChapter);
        // Seek to interaction
      } else if (seekInteraction > 0) {
        console.log(`Seeking Interaction ${seekInteraction}`);
        Player.seek_interaction(seekInteraction);
        // Seek to time
      } else if (seekTime > 0) {
        console.log('Seeking to time', seekTime);
        Player.seek_to(seekTime);
      }
    });
  });

  Player.on('timeupdate', () => {
    SL.set('vtTime', Player.get_state().currentTime);

    // Update timer UI
    update_timers(Player);
  });

  Player.on('play', () => {});

  Player.on('playing', () => {
    SL.set('vtLoading', false);
    SL.set('vtIsPlaying', true);
    Player.update_seekbar_visibility(false);
  });

  Player.on('pause', () => {
    SL.set('vtIsPlaying', false);
    Player.update_seekbar_visibility(true);
  });

  Player.on('ended', () => {
    SL.set('vtEnded', 1);
  });
}

// Interactive Video Player - Update Timer
export function update_timers(Player) {
  try {
    const currentTime = Player.get_state().currentTime;

    // Ensure that currentTime is a number and not NaN
    if (typeof currentTime !== 'number' || isNaN(currentTime)) {
      throw new Error('Invalid current time value');
    }

    Resume.set_resume_time(Player.projectID, currentTime);
    if (Player.seekbarActive) {
      Player.update_seekbar(currentTime);
    }

    let timerInSeconds = currentTime;
    let timerUI;

    switch (Player.timeFormat) {
      case 1:
        timerUI = timerInSeconds.toHHMMSS() + ' / ' + Player.get_state().endTime.toHHMMSS();
        break;
      case 2:
        timerUI = timerInSeconds.toHHMMSS();
        break;
      default:
        timerInSeconds = Player.get_state().endTime - currentTime;
        timerUI = '-' + timerInSeconds.toHHMMSS() + ' / ' + Player.get_state().endTime.toHHMMSS();
        break;
    }

    SL.set('vtCurrentTime', timerUI);
  } catch (error) {
    IVP.log(error.message, 'error');
  }
}
